module.exports = __webpack_public_path__ + "img/sls.66af8c48.png";